export const ROOT_MODULE_NAME = 'axp-consumer-travel-root';
export const MODULE_NAME = 'axp-travel-page-wrapper';
